<div id="Historial" [ngClass]="{ view: view }">
  <div class="historial_container">
    <div class="historial_header">
      <div
        class="item"
        [ngClass]="{ selected: selected == Tabs.record }"
        (click)="selected = Tabs.record"
      >
        <p>{{ Tabs.record }}</p>
      </div>
      <div>
        <i class="fas fa-arrow-right" (click)="clickHidden()"></i>
      </div>
    </div>
    <div class="content">
      <alert-record-items></alert-record-items>
    </div>
  </div>
</div>
